import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicSortDown({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 14h.02a1 1 0 00.07 0H8a1 1 0 00.63-.22l.08-.07 4-4a1 1 0 00-1.32-1.5l-.1.08L9 10.6V3a1 1 0 00-2-.12v7.71l-2.3-2.3a1 1 0 00-1.31-.08l-.1.08a1 1 0 00-.08 1.32l.08.1 4 4 .08.07h.01l-.09-.07A1 1 0 008 14z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicSortDown.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicSortDown.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicSortDown svgRef={ref} {...props} />);
export default ForwardRef;
